import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
    assignLineToStationAPI,
    getAssignmentsByCarrierAPI,
    getAssignmentsByStationAPI,
    getAssignedLineIdsByStationAPI,
    getAssignmentsByCarrierAndStationAPI,
    toggleAssignmentActiveAPI,
    deleteAssignmentAPI,
} from "../../api/stationLineAssignment";

export const fetchAssignmentsByCarrier = createAsyncThunk(
    'stationLineAssignment/fetchByCarrier',
    async (carrierOperatorId) => {
        const response = await getAssignmentsByCarrierAPI(carrierOperatorId);
        return response.data;
    }
);

export const fetchAssignmentsByStation = createAsyncThunk(
    'stationLineAssignment/fetchByStation',
    async (stationOperatorId) => {
        const response = await getAssignmentsByStationAPI(stationOperatorId);
        return response.data;
    }
);

export const fetchAssignedLineIds = createAsyncThunk(
    'stationLineAssignment/fetchLineIds',
    async (stationOperatorId) => {
        const response = await getAssignedLineIdsByStationAPI(stationOperatorId);
        return response.data;
    }
);

export const fetchAssignmentsByCarrierAndStation = createAsyncThunk(
    'stationLineAssignment/fetchByCarrierAndStation',
    async ({ carrierOperatorId, stationOperatorId }) => {
        const response = await getAssignmentsByCarrierAndStationAPI(carrierOperatorId, stationOperatorId);
        return response.data;
    }
);

export const createAssignment = createAsyncThunk(
    'stationLineAssignment/create',
    async (data) => {
        const response = await assignLineToStationAPI(data);
        return response.data;
    }
);

export const toggleAssignmentActive = createAsyncThunk(
    'stationLineAssignment/toggleActive',
    async (id) => {
        const response = await toggleAssignmentActiveAPI(id);
        return response.data;
    }
);

export const removeAssignment = createAsyncThunk(
    'stationLineAssignment/remove',
    async (id) => {
        await deleteAssignmentAPI(id);
        return id;
    }
);

const initialState = {
    assignments: [],
    assignedLineIds: [],
    loading: false,
    error: null,
};

export const stationLineAssignmentSlice = createSlice({
    name: 'stationLineAssignment',
    initialState,
    reducers: {
        clearAssignments: (state) => {
            state.assignments = [];
        },
        clearAssignedLineIds: (state) => {
            state.assignedLineIds = [];
        },
    },
    extraReducers: (builder) => {
        builder
            // fetchAssignmentsByCarrier
            .addCase(fetchAssignmentsByCarrier.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAssignmentsByCarrier.fulfilled, (state, { payload }) => {
                state.assignments = payload;
                state.loading = false;
            })
            .addCase(fetchAssignmentsByCarrier.rejected, (state, { error }) => {
                state.loading = false;
                state.error = error.message;
            })
            // fetchAssignmentsByStation
            .addCase(fetchAssignmentsByStation.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAssignmentsByStation.fulfilled, (state, { payload }) => {
                state.assignments = payload;
                state.loading = false;
            })
            .addCase(fetchAssignmentsByStation.rejected, (state, { error }) => {
                state.loading = false;
                state.error = error.message;
            })
            // fetchAssignedLineIds
            .addCase(fetchAssignedLineIds.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAssignedLineIds.fulfilled, (state, { payload }) => {
                state.assignedLineIds = payload;
                state.loading = false;
            })
            .addCase(fetchAssignedLineIds.rejected, (state, { error }) => {
                state.loading = false;
                state.error = error.message;
            })
            // fetchAssignmentsByCarrierAndStation
            .addCase(fetchAssignmentsByCarrierAndStation.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchAssignmentsByCarrierAndStation.fulfilled, (state, { payload }) => {
                state.assignments = payload;
                state.loading = false;
            })
            .addCase(fetchAssignmentsByCarrierAndStation.rejected, (state, { error }) => {
                state.loading = false;
                state.error = error.message;
            })
            // createAssignment
            .addCase(createAssignment.fulfilled, (state, { payload }) => {
                const existingIndex = state.assignments.findIndex(a => a.id === payload.id);
                if (existingIndex >= 0) {
                    state.assignments[existingIndex] = payload;
                } else {
                    state.assignments.push(payload);
                }
            })
            // toggleAssignmentActive
            .addCase(toggleAssignmentActive.fulfilled, (state, { payload }) => {
                const index = state.assignments.findIndex(a => a.id === payload.id);
                if (index >= 0) {
                    state.assignments[index] = payload;
                }
            })
            // removeAssignment
            .addCase(removeAssignment.fulfilled, (state, { payload }) => {
                state.assignments = state.assignments.filter(a => a.id !== payload);
            });
    }
});

export const { clearAssignments, clearAssignedLineIds } = stationLineAssignmentSlice.actions;
export const stationLineAssignmentReducer = stationLineAssignmentSlice.reducer;
